export function initCopy(): void {
  document.addEventListener('click', (event) => {
    const button = (event.target as HTMLElement | null)?.closest<HTMLElement>('[data-copy]');
    if (!button) return;

    const explicit = button.dataset.copyText;
    const code = button.closest('[data-code]')?.querySelector('pre code');
    const text = explicit ?? code?.textContent ?? '';
    if (!text) return;

    void navigator.clipboard
      .writeText(text)
      .then(() => {
        button.classList.add('is-done');
        setTimeout(() => button.classList.remove('is-done'), 1600);
      })
      .catch(() => {
        /* clipboard denied — leave the button unchanged rather than lying about success */
      });
  });
}
